import CustomInput from "../../component/CustomInput";
import FilledButton from "../../component/FilledButton";
import { useContext, useState } from 'react';
import { rules } from "../../siteData/rules";
import { Form } from "antd";
import { getAdminDetail, logInAdmin, adminforgot_password } from "../../api/auth";
import Cookies from 'universal-cookie';
import publicIp from "public-ip";
import CustomModal from "../../hoc/CustomModal";
import PopComponent from "../popContent";
import { browserName, osName, osVersion, isDesktop, isMobile } from "react-device-detect";
import { useDispatch } from "react-redux";
import { setUserDetails } from "../../redux/userDetails/action";
import { ContextState } from "../../layout";

const SignIn = ({ history }) => {
    const [showPassword, setShowPassword] = useState({ password: false });
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({});
    const [form] = Form.useForm();
    const [error, setError] = useState({});
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState(null);
    const [modalName, setModalName] = useState("UserInfo");
    let Modal = PopComponent[modalName];
    const [openModal, setModalOpen] = useState(false);
    const dispatch = useDispatch();
    const { setContextReducer } = useContext(ContextState);
    const cookies = new Cookies();

    const handleShow = (type) => {
        setShowPassword({ ...showPassword, [type]: !showPassword[type] })
    };

    const getClientIp = async () => await publicIp.v4({
        fallbackUrls: ["https://ifconfig.co/ip"]
    });

    const handleLogin = (data) => {
        let device_info = { ...data }
        getClientIp().then(res => {
            device_info['ip'] = res
            device_info['userAgent'] = window.navigator.appVersion;
            device_info['browser'] = browserName
            device_info['os'] = osName
            device_info['os_version'] = osVersion
            device_info['device'] = isDesktop ? 'desktop' : isMobile ? 'mobile' : 'tablet'
            setLoading(true);
            logInAdmin(device_info).then(res => {
                setLoading(false);
                if (res.data.status === 200) {
                    const { token, userId, role } = res.data;
                    getAdminDetail(userId).then(res => {
                        if (res.data.status === 200) {
                            dispatch(setUserDetails(res.data.data[0]))
                        } else if (res.data.status === 103) {
                            handleOpenModal('ErrorPop', { header: "Info", body: res.data.message })
                        } else {
                            handleOpenModal('ErrorPop', { header: "Error", body: res.data.message })
                        }

                    }).catch(err => {
                        handleOpenModal('ErrorPop', { header: "Error", body: err.response.data.message })
                    });
                    var d = new Date(Date.now() + 12 * (60 * 60 * 1000));
                    cookies.set('cms_access_token', token, { path: '/', expires: d, secure: true, sameSite: 'strict' });
                    cookies.set('cms_u_id', userId, { path: '/', expires: d, secure: true, sameSite: 'strict' });
                    cookies.set('cms_role', role, { path: '/', expires: d, secure: true, sameSite: 'strict' });
                    if (role === 'Contributor') {
                        localStorage.setItem('cms_type', 'pre-college');
                    } else {
                        localStorage.setItem('cms_type', 'skill-up');
                    }
                    if (role === 'Contributor') {
                        setContextReducer({ cms_type: "pre-college", pre_college: true });
                    } else {
                        setContextReducer({ pre_college: false });
                    }
                    history.push('/users');
                } else if (res.data.status === 103) {
                    handleOpenModal('ErrorPop', { header: "Email Doesn't exist", subHeader: data.email, body: res.data.message })
                } else {
                    handleOpenModal('ErrorPop', { header: "Email Doesn't exist", subHeader: data.email, body: res.data.message })
                }

            }).catch(err => {
                setLoading(false);
                handleOpenModal('ErrorPop', { header: "Email Doesn't exist", subHeader: data.email, body: err.response?.data.message })
            });
        });
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.value]: e.target.name });
    };

    const onFocus = () => {
        setEmailError('');
    }

    
    const handleForgotPassword = () => {
        let checkEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
        if (!email) {
            setEmailError("Please enter your registered email to continue");
            return false
        } else if (!checkEmail) {
            setEmailError("Please enter a valid email");
            return false
        }
        const data = {
            email: email
        };
        handleOpenModal();


        adminforgot_password(data).then(res => {
            setLoading(false);
            if (res.data.status === 200) {
                handleOpenModal('ErrorPop', { header: "Success", body: res.data.message })
            }else{
                handleOpenModal('ErrorPop', { header: "Error", body: res.data.message })
                setEmail('')
            }
            
        }).catch(err => {
            setLoading(false);
            handleOpenModal('ErrorPop', { header: "Email Doesn't exist", subHeader: data.email, body: err.response?.data.message })
        });
        // dispatch.SigninModel.forgotPassword(data);
    };


    const handleOpenModal = (type, data) => {
        let flag = 0;
        switch (type) {
           case 'ResetpasswordPop': {
                setModalName(type);
                setError(data)
                setModalOpen(!openModal);
                break;
            }
            case 'ErrorPop': {
                setModalName(type);
                setError(data)
                setModalOpen(true);
                break;
            }
            default: {
                setModalName(type);
                setModalOpen(!openModal);
                setEmail('')
                break;
            }
        }
        if (flag === 1) {
            setModalName(type);
            setModalOpen(!openModal);
        }
    };

    const reSendEmail = (data) => {
        dispatch.SigninModel.reSendMail({ email: data });
        handleOpenModal();
    };

    return (
        <div className="signin">
            <h2 className="text_uppercase">Sign In</h2>
            <Form
                form={form}
                name="register"
                onFinish={handleLogin}
                initialValues={formData}
                scrollToFirstError
                className="form"
            >
                <Form.Item name="email" rules={rules.email} className="form_item">
                    <CustomInput
                        name="email"
                        label="Email"
                        onChange={handleChange}
                    />
                </Form.Item>
                <Form.Item name="password" rules={rules.password} className="form_item">
                    <CustomInput
                        name="password"
                        label="Password"
                        type="password"
                        onChange={handleChange}
                        handleShow={handleShow}
                        showPassword={showPassword}
                    />
                </Form.Item>
                <p className="forgot" onClick={() =>
                    handleOpenModal('ResetpasswordPop', {
                        header: "reset password",
                        forget: true,
                        body: "Please enter your email address below and we'll send you an email to reset your password."
                    })}>Forgot Password?</p>
                <div className="form_group form_footer d_flex_center">
                    <FilledButton type="reset" className="btn btn_gray" value="Clear" />
                    <FilledButton type="submit" loading={loading} className="btn btn_primary" value="submit" />
                </div>
            </Form>
            {
                Modal && (
                    <CustomModal className={`${modalName === 'EditThoughtLeader' || modalName === 'AddThoughtLeader' ? "ant-modal modal peak_model thought_leader_modal" : "modal skill_model"} ${modalName === 'ErrorPop' ? 'errorPop' : modalName === "ResetpasswordPop" ? 'errorPop' : ''}`} handleOpen={handleOpenModal} open={openModal}>
                        <Modal
                            error={error}
                            handleOpenModal={handleOpenModal}
                            loading={loading}
                            email={email}
                            emailError={emailError}
                            setEmail={setEmail}
                            onFocus={onFocus}
                            handleSubmit={handleForgotPassword}
                            subBodyFunction={reSendEmail}
                        />
                    </CustomModal>
                )
            }
        </div>
    )
}

export default SignIn;